/* eslint-disable import/no-extraneous-dependencies */
import sdkSessionUtil from 'bam-browser-sdk-sdkSession-util';

let _sdkSession;

export default async function getSdkSession() {

    if (!_sdkSession) {
        _sdkSession = await sdkSessionUtil.getSdkSession();
    }
    return _sdkSession;
}
